"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifMatch = void 0;
/** ifMatch takes a parameter object to check against the event,
* - booleans mean we just check truthy-ness,
* - strings and numbers we check the precise value
* - for array fields we do an includes check.
* */
function ifMatch(evt, matcher, callback) {
    const isNameMatch = !matcher.name || (evt.eventName === matcher.name);
    const isContextMatch = !matcher.context || Object.entries(matcher.context).every(([key, matchValue]) => {
        const evtValue = evt.context[key];
        if (typeof matchValue === 'boolean') {
            return !!evtValue;
        }
        if (Array.isArray(evtValue)) {
            return evtValue.includes(matchValue);
        }
        return evtValue === matchValue;
    });
    if (isContextMatch && isNameMatch) {
        callback();
    }
}
exports.ifMatch = ifMatch;
//# sourceMappingURL=ifmatch.js.map